import { render, staticRenderFns } from "./settlementDetails.vue?vue&type=template&id=70df7ad2&scoped=true"
import script from "./settlementDetails.vue?vue&type=script&lang=js"
export * from "./settlementDetails.vue?vue&type=script&lang=js"
import style0 from "./settlementDetails.vue?vue&type=style&index=0&id=70df7ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df7ad2",
  null
  
)

export default component.exports